<template>
	<div>
		<div class="content mt-5" id="rows-slot">
			<p>Finally, you can create the rows completely by hand with <code>rows</code> scoped slot:</p>
			<pre v-highlightjs class="box pa-0"><code class="html" v-pre>&lt;ui-table :items=&quot;items&quot; hide-headers&gt;
	&lt;template #rows=&quot;{ rows }&quot;&gt;
		&lt;tr&gt;
			&lt;th v-for=&quot;{ item, itemKey } in rows&quot; :key=&quot;`id-${itemKey}`&quot;&gt;#{{item.id}}&lt;/th&gt;
		&lt;/tr&gt;
		&lt;tr&gt;
			&lt;td v-for=&quot;{ item, itemKey } in rows&quot; :key=&quot;`title-${itemKey}`&quot;&gt;{{item.title}}&lt;/td&gt;
		&lt;/tr&gt;
		&lt;tr&gt;
			&lt;td v-for=&quot;{ item, itemKey } in rows&quot; :key=&quot;`body-${itemKey}`&quot;&gt;{{item.body}}&lt;/td&gt;
		&lt;/tr&gt;
	&lt;/template&gt;
&lt;/ui-table&gt;</code></pre>
		</div>
		<ui-table :items="items" container-class="box" hide-headers>
			<template #rows="{ rows }">
				<tr>
					<th v-for="{ item, itemKey } in rows" :key="`id-${itemKey}`">#{{item.id}}</th>
				</tr>
				<tr>
					<td v-for="{ item, itemKey } in rows" :key="`title-${itemKey}`">{{item.title}}</td>
				</tr>
				<tr>
					<td v-for="{ item, itemKey } in rows" :key="`body-${itemKey}`">{{item.body}}</td>
				</tr>
			</template>
		</ui-table>
	</div>
</template>

<script>

    export default {
        name: "rows-slot",
		props: {
            items: Array
		}
    }
</script>